<template>
  <div class="quiz-state" :class="`is-${state}`">
    <div class="quiz-state__top">
      <button class="quiz-state__back" @click="$emit('back')"></button>
      <button class="quiz-state__rules" @click="$emit('rules')">规则&好礼</button>
    </div>
    <div class="quiz-state__hero">
      <div class="quiz-state__brand">世界杯竞猜</div>
      <div class="quiz-state__subtitle">按场次竞猜 · 猜中抽好礼</div>
    </div>
    <div class="quiz-state__panel">
      <template v-if="state === 'loading'">
        <div class="quiz-state__spinner"></div>
        <div class="quiz-state__loading-text">加载中...</div>
      </template>
      <template v-else>
        <img class="quiz-state__error-image" :src="networkErrorImage" alt="">
        <div class="quiz-state__title">{{ title }}</div>
        <div class="quiz-state__text">{{ text }}</div>
        <button v-if="retry" class="quiz-state__button" @click="$emit('retry')">点击重试</button>
      </template>
    </div>
  </div>
</template>

<script>
import networkErrorImage from '@/assets/image/worldcupQuiz/network-error.png'

export default {
  name: 'WorldCupQuizState',
  data () {
    return {
      networkErrorImage
    }
  },
  props: {
    state: {
      type: String,
      default: 'loading'
    },
    title: {
      type: String,
      default: '加载失败'
    },
    text: {
      type: String,
      default: '网络异常，请稍后重试'
    },
    retry: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.quiz-state {
  position: relative;
  min-height: 100vh;
  padding: 0;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  max-width: 480px;
  margin: 0 auto;
  overflow: hidden;
  background: #145720;
}

.quiz-state__top {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 480px;
  height: calc(var(--quiz-safe-top, 0px) + var(--quiz-nav-height, 48px));
  padding: var(--quiz-safe-top, 0px) 18px 0;
  box-sizing: border-box;
  transform: translateX(-50%);
  color: #fff;
}

.quiz-state__back,
.quiz-state__rules {
  border: 0;
  background: transparent;
}

.quiz-state__back {
  position: relative;
  width: 32px;
  height: 32px;
}

.quiz-state__back:before {
  content: "";
  position: absolute;
  top: 9px;
  left: 10px;
  width: 10px;
  height: 10px;
  border-left: 2px solid rgba(255, 255, 255, .92);
  border-bottom: 2px solid rgba(255, 255, 255, .92);
  transform: rotate(45deg);
}

.quiz-state__rules {
  height: 32px;
  padding: 0;
  color: rgba(255, 255, 255, .96);
  font-size: 14px;
  font-weight: 700;
}

.quiz-state__hero {
  position: relative;
  min-height: 470px;
  padding: 0;
  box-sizing: border-box;
  color: #fff;
  background:
    linear-gradient(180deg, rgba(20, 87, 32, 0) 0%, rgba(20, 87, 32, 0) 88%, #145720 100%),
    url('~@/assets/image/worldcupQuiz/hero.png') center top/100% auto no-repeat;
}

.quiz-state__brand {
  display: none;
  margin-top: 62px;
  color: #ffe76e;
  text-shadow: 0 3px 0 #0e4a22, 0 8px 16px rgba(0, 0, 0, .45);
  font-size: 42px;
  font-weight: 900;
  line-height: 1.05;
}

.quiz-state__subtitle {
  display: none;
  margin-top: 10px;
  padding: 5px 12px;
  border: 2px solid rgba(255, 225, 92, .9);
  border-radius: 2px;
  color: #ffe76e;
  background: rgba(20, 87, 32, .88);
  font-size: 13px;
  font-weight: 800;
}

.quiz-state__panel {
  position: relative;
  z-index: 1;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 400px);
  margin-top: -70px;
  padding-top: 156px;
  box-sizing: border-box;
  border-radius: 22px 22px 0 0;
  background:
    radial-gradient(ellipse at 50% 145px, rgba(255, 255, 255, .12), transparent 36%),
    linear-gradient(180deg, transparent 0, transparent 145px, rgba(20, 87, 32, .96) 145px, #145720 100%);
}

.quiz-state__panel:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 145px;
  pointer-events: none;
  box-sizing: border-box;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, .16) 0%, rgba(255, 255, 255, 0) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.quiz-state__panel > * {
  position: relative;
  z-index: 1;
}

.quiz-state__spinner {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, .24);
  border-top-color: #fff;
  border-radius: 50%;
  animation: quiz-loading 900ms linear infinite;
}

.quiz-state__loading-text {
  margin-top: 12px;
  color: rgba(255, 255, 255, .88);
  font-size: 14px;
}

.quiz-state__error-image {
  width: 145px;
  height: 108px;
  margin-top: -80px;
  margin-bottom: 18px;
  object-fit: contain;
}

.quiz-state__title {
  color: rgba(255, 255, 255, .72);
  font-size: 18px;
  font-weight: 800;
}

.quiz-state__text {
  margin-top: 8px;
  color: rgba(255, 255, 255, .72);
  font-size: 13px;
}

.quiz-state__button {
  min-width: 184px;
  height: 48px;
  margin-top: 24px;
  border: 0;
  border-radius: 24px;
  color: #145720;
  background: linear-gradient(180deg, #ffe56b, #ffb94a);
  font-size: 16px;
  font-weight: 600;
}

@keyframes quiz-loading {
  to {
    transform: rotate(360deg);
  }
}
</style>
